/**
 * Visual identity for the production stories — CSS/SVG motifs, not WebGL.
 *
 * The per-level motif DATA now lives in `content/levels/{slug}/level.json`; this
 * module keeps the shape types + the stable `storyMotifFor` lookup (with its
 * generic fallback), backed by the loader (`content/levels/index.ts`).
 */
import { STORY_MOTIFS } from "../../content/levels/index.js";

/** A level's pack id. Open by design: adding a level must not be a type error. */
export type StoryMotifId = string;

export interface StoryMotif {
  id: StoryMotifId;
  accent: string;
  motif: string;
  kit: string;
  /**
   * Short CSS motif class suffix, e.g. "cat" -> `.story-motif-cat`. Authored in
   * the level's level.json; a level shipping a class with no stylesheet rule
   * simply gets the unstyled default rather than failing to compile.
   */
  motifClass: string;
}

export { STORY_MOTIFS };

/** Neutral motif for an unknown pack id — never a specific level's identity. */
const GENERIC_MOTIF: StoryMotif = {
  id: "unknown",
  accent: "#c45c26",
  motif: "story",
  kit: "Studio",
  motifClass: "generic",
};

export function storyMotifFor(packId: string): StoryMotif {
  return STORY_MOTIFS[packId] ?? GENERIC_MOTIF;
}
